import { render } from "./pruefungsanmeldung.vue?vue&type=template&id=0b40ad1d"
import script from "./pruefungsanmeldung.vue?vue&type=script&lang=js"
export * from "./pruefungsanmeldung.vue?vue&type=script&lang=js"

import "./pruefungsanmeldung.vue?vue&type=style&index=0&id=0b40ad1d&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__